import { ForwardedRef, forwardRef, ReactNode } from "react";

import { sanitizer } from "./sanitize";
import { StyledHtml } from "./html.styles";

export const Html = forwardRef(function Html(
  { content }: { content: string },
  ref: ForwardedRef<HTMLDivElement>,
): ReactNode {
  return <StyledHtml dangerouslySetInnerHTML={{ __html: sanitizer(content) }} ref={ref} />;
});
